import {FutureBidRow, TableKey, MatchedOffer} from '@tradecafe/types/core'
import { keyBy, mapValues } from 'lodash-es';
import { ColumnDef } from 'src/services/table-utils';


export type FutureBidRow2 = FutureBidRow & {
  isNotSubRow: boolean;
  is_delivery_date_active: boolean;
  isExpired: boolean;
  matchedOffer: MatchedOffer;
  bidding: {
    "bidPercentage": number,
    "bidPartialMargin": number,
    "bidPartialMarginCad": number,
    "isBiggestBidPartialMargin": boolean,
    "bidPrice": number
  }
  deal_id?: string
  inventory_deal_id?: string
};

export const FUTURE_BIDS_COLUMNS: ColumnDef[] = [
  { field: 'actionMenu', displayName: '', internal: true, index: 1001 },
  {
    field: 'deal_id',
    displayName: 'Deal #',
    exportField: 'deal_id',
    exportPipe: 'fakeId',
  },
  {
    field: 'bidPartialMargin',
    displayName: 'Bid PM',
    exportField: 'bidding.bidPartialMargin',
    exportPipe: '',
  },
  {
    field: 'matched_offer_id',
    displayName: 'Matched Offer #',
    exportField: 'matched_offer_id',
    exportPipe: 'fakeId',
  },
  {
    field: 'status',
    displayName: 'Status',
    exportField: 'status',
    exportPipe: '',
  },
  {
    field: 'buyer_price',
    displayName: 'MO Price',
    exportField: 'buyer_price',
    exportPipe: '',
  },
  {
    field: 'offer_price',
    displayName: 'SO Price',
    exportField: 'offer_price',
    exportPipe: '',
  },
  {
    field: 'fob_price',
    displayName: 'FOB Bid',
    exportField: 'fob_price',
    exportPipe: '',
  },
  {
    field: 'buyerName',
    displayName: 'Buyer',
    exportField: 'buyerName',
    exportPipe: '',
  },
  {
    field: 'supplierName',
    displayName: 'Supplier',
    exportField: 'supplierName',
    exportPipe: '',
  },
  {
    field: 'productName',
    displayName: 'Product',
    exportField: 'productName',
    exportPipe: '',
  },
  {
    field: 'productPlus',
    displayName: 'Product +',
    exportField: 'product_plus',
    exportPipe: '',
  },
  {
    field: 'price',
    displayName: 'Bid Price',
    exportField: 'price',
    exportPipe: 'currency',
  },
  {
    field: 'futureDates',
    displayName: 'Delivery Date',
    exportField: 'futureDates',
    exportPipe: 'epochRange',
  },
  {
    field: 'shipmentDates',
    displayName: 'Shipment Dates',
    exportField: 'shipmentDates',
    exportPipe: 'epochRange',
  },
  {
    field: 'deliveryLocation',
    displayName: 'Location',
    exportField: 'deliveryLocation',
    exportPipe: '',
  },
  {
    field: 'pickupLocation',
    displayName: 'Pickup Location',
    exportField: 'pickupLocation',
    exportPipe: '',
  },
  {
    field: 'productSpecification',
    displayName: 'Product Specification',
    exportField: 'productSpecification',
    exportPipe: '',
  },
  {
    field: 'created',
    displayName: 'Offer Created',
    exportField: 'created',
    exportPipe: 'epoch',
  },
  {
    field: 'updated',
    displayName: 'Date of Bidding',
    exportField: 'updated',
    exportPipe: 'epoch',
  }
];

export const EXTRA_COLUMNS_EXPORT_FIELDS = [
  {
    "field": "deal_status",
    "displayName": "Deal Status",
    "exportField": "deal_status",
    "exportPipe": ""
  },
  {
    "field": "status",
    "displayName": "Status",
    "exportField": "status",
    "exportPipe": ""
  }
]

export const EXTRA_COLUMNS_EXPORT_FIELDS_AVAILABLE = [
  "bidding",
  "buyer",
  "supplier",
  "product",
  "origin_country",
  "delivery",
  "item_type",
  "deal",
  "matched_offer",
  "matched_offers",
  "deal_status",
]

export const FUTURE_BIDS_COLUMN_NAMES = mapValues(
  keyBy(FUTURE_BIDS_COLUMNS, 'field'),
  'displayName',
);
const FUTURE_BIDS_COLUMN_OVERRIDES = {};

export function columnDefsById(tableKey: TableKey) {
  const displayNames = FUTURE_BIDS_COLUMN_OVERRIDES[tableKey] || {};
  const columnDefs = FUTURE_BIDS_COLUMNS.map((c) =>
    displayNames[c.field]
      ? ({ ...c, displayName: displayNames[c.field] } as ColumnDef)
      : c,
  );
  return keyBy(columnDefs, (c) => c.field);
}

export function columnNames(tableKey: TableKey) {
  return {
    ...FUTURE_BIDS_COLUMN_NAMES,
    ...FUTURE_BIDS_COLUMN_OVERRIDES[tableKey],
  };
}

export const AVAILABLE_COLUMNS: Partial<Record<TableKey, string[]>> = {
  [TableKey.TradingFutureBidsPage]: [
    'deal_id',
    'matched_offer_id',
    'status',
    'buyer_price',
    'offer_price',
    'fob_price',
    'buyerName',
    'supplierName',
    'productName',
    'productPlus',
    'price',
    'futureDates',
    'shipmentDates',
    'deliveryLocation',
    'pickupLocation',
    'supplier',
    'productSpecification',
    'created',
    'updated',
    'bidPartialMargin',
    'actionMenu',
  ],
};

export const DEFAULT_COLUMNS: Partial<Record<TableKey, string[]>> = {
  [TableKey.TradingFutureBidsPage]: [
    'deal_id',
    'matched_offer_id',
    'status',
    'buyer_price',
    'offer_price',
    'fob_price',
    'buyerName',
    'productName',
    'price',
    'futureDates',
    'shipmentDates',
    'deliveryLocation',
    'updated',
    'actionMenu',
  ],
};
